import { Text, Flex } from "@chakra-ui/react";
import Lottie from "lottie-react";
import * as animationData from "./assets/data2.json";

const Slider2 = () => {
  return (
    <Flex
      sx={{
        height: "100%",
        position: "relative",
      }}
      align={"center"}
      justify={"center"}
      flexDir={"column"}
    >
      <Text
        sx={{
          color: "#333",
          fontFamily: "DIN",
          fontSize: "14px",
          fontWeight: 500,
          position: "absolute",
          top: "20px",
          left: "0",
          zIndex: 10,
        }}
      >
        Welcome to Logs
      </Text>
      <Lottie
        animationData={animationData}
        loop={true}
        style={{
          width: "300px",
          marginTop: "auto",
        }}
      />

      <Text
        sx={{
          fontSize: "24px",
          fontFamily: "DIN-Black",
          marginTop: "auto",
          width: "100%",
        }}
      >
        Money in your bank, instantly
      </Text>
      <Text
        sx={{
          color: "#333",
          fontSize: "16px",
          fontWeight: 400,
          width: "100%",
          marginTop: "15px",
        }}
      >
        Receive your preferred currecy in your bank within one business day. We
        handle the rest.
      </Text>
    </Flex>
  );
};

export default Slider2;
